import qs from 'qs';

const SOCIALHOUR_BASE_DOMAIN = 'techchange.frameable.com';

export const FARRAGUT_OF_THE_FUTURE_DELIMITER = 't';

/**
 * Converts a URL to the format expected by the TechChange Link APIs.
 *
 * @param {string} url         The original URL.
 * @param {string} scope       The link scope.
 * @param {string} scopeId     The link scope ID.
 * @param {string} resourceId  The resource ID (if any) for the link.
 *
 * @returns {string} result    The result URL.
 */
export const buildTCLinkURL = (url, scope, scopeId, resourceId) => {

	const params = {
		to: encodeURIComponent(url),
		scope,
		scope_id: scopeId,
	};

	if (resourceId) {
		params.id = resourceId;
	}

	// Check if the link is for a room via the socialhour integration...
	if (url.startsWith(`https://${SOCIALHOUR_BASE_DOMAIN}/`)) {

		return `https://${window.location.host}/redirect/external?${qs.stringify(params)}`;

	}

	// Otherwise, convert the link to use the TechChange link API handler...
	return `https://${window.location.host}/api/v2/links?${qs.stringify(params)}`;

};

/**
 * Builds the relative URL to the session for both Farragut of the Future and WordPress sessions.
 *
 * @param {object} session   The session.
 *
 * @returns {string} result  The relative URL to the session.
 */
export const tcBuildSessionURL = (session) => {

	return `/${FARRAGUT_OF_THE_FUTURE_DELIMITER}/${session.slug}`;

};
